export const searchFilter = (
  string1: string | null,
  string2: string
): boolean => {
  if (!string1) return false;
  else return string1.toLowerCase().indexOf(string2.toLowerCase()) !== -1;
};
